angular.module('dentalLinks')
.controller('NotificationAreaController', ['$scope', 'Notification',
    function ($scope,  Notification) {
        $scope.notification = Notification.get();

        // DCL-412: manual dismiss control (the toast's × button) so a validation
        // error doesn't require a page refresh to get rid of.
        $scope.dismiss = function () {
            Notification.dismiss();
        };

        // DCL-462: HTML toasts (compiled by dynamic-html against this scope)
        // can carry an action callback in params — e.g. the email-suppression
        // warning's "See details" link opening its dialog.
        $scope.notificationAction = function () {
            var current = Notification.get();
            if (current.params && typeof current.params.action === 'function') {
                current.params.action();
            }
        };
    }]);
